import { useEffect } from 'react';
import { listenTripPositionsAnalysis } from '../../channels/tripPositionsAnalysisChannel';
import { useTripPositionsAnalysisStore } from '../../stores/analysis/useTripPositionsAnalysisStore';

export function useTripPositionsAnalysisChannel() {

    useEffect(() => {

        const unsubscribe = listenTripPositionsAnalysis(({ tipo, payload }) => {

            const {
                setPosition,
                setPositionsBatch,
                deletePosition
            } = useTripPositionsAnalysisStore.getState();

            if (tipo === 'trip-position-analysis-upsert') {
                setPosition(payload, false);
            }

            if (tipo === 'trip-position-analysis-batch-upsert') {
                setPositionsBatch(payload, false);
            }

            if (tipo === 'trip-position-analysis-delete') {
                deletePosition(payload.date, payload.codigo, false);
            }

        });

        return unsubscribe;

    }, []);

}